import { createComplianceInformationController } from './compliance-information-controller'
import { createComplianceInformationV2Validation } from './compliance-information-v2-validation'

const replaceArray = (target, values) => {
    target.splice(0, target.length, ...(values || []))
}

const createComplianceInformationV2Controller = dependencies => {
    const baseController = createComplianceInformationController({
        ...dependencies,
        propertySaveDelay: 1500,
        refreshSubstancesAfterPropertySave: false,
        refreshSubstanceStateAfterSave: false,
    })
    const { context } = dependencies

    return Object.freeze({
        ...baseController,
        async load() {
            const state = context.complianceInformation
            const completedProcessingRevision = Number(
                context.documentsAndWebpages.completedProcessingRevision,
            ) || 0
            const appliedProcessingRevision = Number(
                state.appliedDocumentProcessingRevision,
            ) || 0
            const complex = (context.request && context.request.isComplexProduct === true)
                || (context.product && context.product.isComplex === true)
            if (!complex) {
                state.loaded = false
                const pendingValidation = { isValid: false, errors: [] }
                baseController.setValidation(pendingValidation)
                if (typeof dependencies.setValidity === 'function') dependencies.setValidity(pendingValidation)
            }
            const concernDataPromise = completedProcessingRevision > appliedProcessingRevision
                ? baseController.refreshAfterDocumentProcessing()
                : baseController.load()
            const safetyInstructionsPromise = complex
                ? Promise.resolve(null)
                : context.services.getProductSafetyInstructions()
            const [
                substanceLists,
                propertyConfig,
                visibilityContext,
                safetyInstructions,
            ] = await Promise.all([
                context.services.getComplianceSubstanceLists(),
                context.services.getComplianceSubstancePropertyConfig(),
                context.services.getComplianceSubstanceListVisibilityContext(),
                safetyInstructionsPromise,
                concernDataPromise,
            ])

            replaceArray(state.substanceLists, substanceLists)
            state.propertyConfig = propertyConfig
            state.visibilityContext = visibilityContext
            if (safetyInstructions) {
                Object.assign(state.safetyInstructions, safetyInstructions, { loaded: true })
            }
            state.loaded = true

            const validation = createComplianceInformationV2Validation(
                context,
                (dependencies.step && dependencies.step.settings) || {},
            )
            baseController.setValidation(validation)
            if (typeof dependencies.setValidity === 'function') {
                dependencies.setValidity(validation)
            }
        },
    })
}

export { createComplianceInformationV2Controller }
export default createComplianceInformationV2Controller
